module.exports = __webpack_public_path__ + "content/dam/oppo/coloros/img/watch.bdd03bff.png";